<template>
  <div class="pa-4">
    <v-row>
      <v-col cols="12">
        <v-btn light color="amber" @click="addItem" class="mb-4"
          >Add Challenge</v-btn
        >
        <v-row>
          <v-col v-for="item in proxyItems" :key="item.id" cols="3">
            <v-card height="100%">
              <v-card-text>
                <ChallengeCard :el="item" :attrs="attrs" />
              </v-card-text>
              <v-card-actions class="pa-4">
                <v-btn x-small @click="editItem(item)">Edit</v-btn>
                <v-btn x-small @click="deleteItem(item)">Delete</v-btn>
                <v-btn x-small @click="copyItem(item)">Copy</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" max-width="800">
      <v-card light v-if="dialogMode == 'add'">
        <v-card-title class="headline">Adding item</v-card-title>
        <v-card-text>
          <ItemForm
            :key="`${activeItem.id}-${editKey}`"
            :new-item="activeItem"
            :colors="colors"
            :local="local"
            @submit="commitSave"
            @cancel="closeDialog"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card light v-if="dialogMode == 'edit'">
        <v-card-title class="headline">Editing item</v-card-title>
        <v-card-text>
          <ItemForm
            :key="`${activeItem.id}-${editKey}`"
            :new-item="activeItem"
            :colors="colors"
            :local="local"
            @submit="commitEdit"
            @cancel="closeDialog"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card light v-if="dialogMode == 'delete'">
        <v-card-title class="headline"
          >Are you sure you want to delete this item?</v-card-title
        >

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="commitDelete">
            Confirm
          </v-btn>
          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ChallengeCard from "@/views/user/exercises/challenges-system/ChallengeCard";
import ItemForm from "@/views/user/exercises/challenges-system/ItemForm";
import ChallengesMixin from "@/views/user/exercises/challenges-system/ChallengesMixin";

export default {
  name: "Challenges",
  mixins: [ChallengesMixin],
  components: {
    ChallengeCard,
    ItemForm,
  },
  methods: {},
};
</script>
